import React from "react";
import dayjs from "lib/dayjs";
import SectionCard from "components/SectionCard";

const money = (value) =>
  Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
const decimal = (value, digits = 2) =>
  Number(value).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

function Metric({ label, value }) {
  return (
    <div className="flex flex-col">
      <span className="text-muted text-sm">{label}</span>
      <span className="font-medium text-app">{value}</span>
    </div>
  );
}

export default function UsTreasuryStats({ result, universeLabel = "Hypothetical" }) {
  const stats = result?.summary;
  if (!result?.rows?.length || !stats) {
    return <div className="text-muted italic">No {result?.universeLabel || universeLabel} calculation available yet.</div>;
  }

  return (
    <div className="space-y-8">
      <SectionCard title="Summary">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-y-3 gap-x-6 text-app">
          <Metric label="Total Cash Outflows" value={`$${money(stats.totalGrossCashFlows)}`} />
          <Metric label="Weighted Avg Interpolated Yield" value={`${decimal(stats.weightedAverageInterpolatedYieldPct, 6)}%`} />
          <Metric label="Number of Cash Flows" value={decimal(stats.cashFlowCount, 0)} />
          <Metric label="Earliest Cash Flow" value={dayjs(stats.earliestCashFlowDate).format("MMM D, YYYY")} />
          <Metric label="Latest Cash Flow" value={dayjs(stats.latestCashFlowDate).format("MMM D, YYYY")} />
          <Metric label="Weighted Average Life" value={`${decimal(stats.weightedAverageLife, 3)} years`} />
        </div>
      </SectionCard>

      <SectionCard title="Performance">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-y-3 gap-x-6 text-app">
          <Metric label="Hypothetical Portfolio Cost (NPV)" value={`$${money(stats.portfolioCost)}`} />
          <Metric label="Total Discount" value={`$${money(stats.totalDiscount)}`} />
          <Metric label="Effective Portfolio Yield" value={`${decimal(stats.portfolioXirrPct, 6)}%`} />
        </div>
        <p className="mt-4 text-xs text-muted">
          Effective Portfolio Yield is an annual effective IRR using Actual/365 timing
          from the market as-of date.
        </p>
      </SectionCard>
    </div>
  );
}
